import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { isDefined } from '../../utils';
import { SchemaContext, SchemaProvider } from '../../providers/SchemaProvider';
import { AutoField } from '../AutoField';
export const ObjectFieldInner = ({ propName, requiredProperties }) => {
    var _a;
    const { schema } = useContext(SchemaContext);
    return (_jsx(_Fragment, { children: Object.entries((_a = schema.properties) !== null && _a !== void 0 ? _a : {})
            .filter(([_, propertySchema]) => {
            return isDefined(propertySchema) && Object.keys(propertySchema).length > 0;
        })
            .map(([propertyName, propertySchema]) => {
            const name = `${propName}.${propertyName}`;
            const required = requiredProperties.includes(propertyName);
            return (_jsx(SchemaProvider, { schema: propertySchema, children: _jsx(AutoField, { propName: name, required: required }) }, name));
        }) }));
};
//# sourceMappingURL=ObjectFieldInner.js.map